module.exports = __webpack_public_path__ + "static/img/mecanica.4bef57b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mecanica.jpg
// module id = cICb
// module chunks = 1